import { useMemo } from 'react';

import { StaffFilterSelection } from '../types';

type StaffFilterParams = {
  my_orders?: boolean;
  my_customers?: boolean;
  staff_id?: number;
};

/**
 * Hook to derive API parameters from the staff filter selection.
 * Used by Orders and Customers pages to get the correct filter params.
 *
 * @param selection - The current staff filter selection
 * @returns API parameters for filtering by staff
 */
export const useStaffFilterParams = (selection: StaffFilterSelection): StaffFilterParams => {
  return useMemo(() => {
    switch (selection.type) {
      case 'everyone':
        return {
          my_orders: undefined,
          my_customers: undefined,
          staff_id: undefined,
        };
      case 'current_user':
        return {
          my_orders: true,
          my_customers: true,
          staff_id: undefined,
        };
      case 'specific_staff':
        return {
          my_orders: undefined,
          my_customers: undefined,
          staff_id: selection.staff.id,
        };
    }
  }, [selection]);
};
